var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"toggleWidget",on:{"click":function($event){return _vm.$emit('toggle')}}},[_vm._v("\n  "+_vm._s(_vm.value)+"\n  "),_c('Icon',{attrs:{"icon":_vm.icon}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac9ba184","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/googleMap/buttons/ToggleWidget.vue
// module id = 665
// module chunks = 1